<template>
    <div class="w-full flex items-center">
        <div class="flex items-center" v-for="(item, index) in items" :key="index">
            <router-link v-if="item.path" :to="item.path" class="text-primaryLight hover:text-purple-pink cursor-pointer">{{ item.label }}</router-link>
            <span v-else class="text-purple-pink">{{ item.label }}</span>
            <span v-if="index < items.length - 1" class="mx-2">
                <icon-chevron-double-right class="h-6 w-6 text-secondaryLight"></icon-chevron-double-right>
            </span>
        </div>
    </div>
</template>

<script>
import IconChevronDoubleRight from '../icons/IconChevronDoubleRight.vue';
export default {
    name: "bread-crumb",
    components: {
        IconChevronDoubleRight,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
};
</script>